import { IMongoDocument } from "utils/types"

export interface IInfoModal extends IMongoDocument {
  lang: string
  type: INFO_MODAL_TYPE
  body: string
  action?: {
    link: string
    text: string
  }
}

export enum INFO_MODAL_TYPE {
  NEWS_FEED = "news-feed",
  NEWS_MINE = "mine",
  TUTORIAL = "tutorial",
  TERMS = "terms",
  POLICY = "policy",
  AML = "aml"
}

export interface INewsMessage {
  _id: string
  lang: string
  type: INFO_MODAL_TYPE
  body: string
  action?: {
    link: string
    text: string
  }
  updatedAt: Date
}

export interface IInfoModalReq {
  type: INFO_MODAL_TYPE
  lang: string
}

export interface IInfoModalRead extends IMongoDocument {
  modalType: INFO_MODAL_TYPE
  userId: string
  lang: string
  contentUpdatedAt: string
  redAt: string
}
